import qs from 'qs';
import { axiosPrivate } from 'app/utils';
import helpers from './helpers';

export default {
  async exportAllAppointments(startDate, endDate) {
    try {
      const query = qs.stringify({ startDate, endDate });
      const response = await axiosPrivate.get(`/dashboard/appointments/download?${query}`);
      if (response.data.error) helpers.throwError(response.data.error);

      return response.data;
    } catch (error) {
      return helpers.throwError(error.response.data.error);
    }
  },
  async appointmentsChartData(chartId, startDate, endDate, serviceIds, pharmacyIds = []) {
    try {
      const query = qs.stringify({ startDate, endDate });
      const serviceQuery = serviceIds.map((serviceId) => `serviceIds=${serviceId}`).join('&');
      const pharmacyQuery = pharmacyIds.map((pharmacyId) => `pharmacyIds=${pharmacyId}`).join('&');
      const response = await axiosPrivate.get(
        `/dashboard/appointments/charts/${chartId}?${query}&${serviceQuery}&${pharmacyQuery}`
      );

      if (response.data.error) helpers.throwError(response.data.error);

      return response.data;
    } catch (error) {
      return helpers.throwError(error.response.data.error);
    }
  },
  async appointmentsTopServices(startDate, endDate) {
    try {
      const query = qs.stringify({ startDate, endDate });
      const response = await axiosPrivate.get(`/dashboard/appointments/top-services?${query}`);
      if (response.data.error) helpers.throwError(response.data.error);
      return response.data;
    } catch (error) {
      return helpers.throwError(error.response.data.error);
    }
  },
};
